import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { LanguageToggle } from '../ui/LanguageToggle';
import { Button } from '../ui/Button';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackBookingCtaClick } from '../../utils/metaPixel';
import { scrollToBooking } from '../../utils/scrollToBooking';
export function Navbar() {
  const {
    t
  } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    href: '#beneficios',
    label: t('nav.benefits')
  }, {
    href: '#proceso',
    label: t('nav.process')
  }, {
    href: '#doctor',
    label: t('nav.doctor')
  }, {
    href: '#testimonios',
    label: t('nav.testimonials')
  }, {
    href: '#preguntas',
    label: t('nav.faq')
  }];
  const scrollToContact = () => {
    trackBookingCtaClick('navbar');
    scrollToBooking();
    setIsMobileMenuOpen(false);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-brand-cream/95 backdrop-blur-md border-b border-brand-stone/50 py-4' : 'bg-transparent py-6'}`} data-id="element-259" data-mp="3qsrcqe4licij">
      <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-260" data-mp="4lt3lh5bd90n">
        <a href="#" className="flex items-baseline gap-1.5 group" data-id="element-261" data-mp="ico528dhgnu7">
          <span className="text-2xl font-serif font-normal text-brand-dark transition-colors" data-id="element-262" data-mp="dewepishl9s4">
            Lipo Laser
          </span>
          <span className="text-[10px] font-medium tracking-[0.2em] uppercase text-brand-gold" data-id="element-263" data-mp="scorw4ak9m35">
            Beverly Hills
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9" data-id="element-264" data-mp="ug0kkstolis1">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/70 hover:text-brand-dark transition-colors" data-id="element-265" data-mp="zf3dxg0au0k6">
              {link.label}
            </a>)}
        </nav>

        <div className="hidden lg:flex items-center gap-6" data-id="element-266" data-mp="196pu7qrhupts">
          <LanguageToggle data-id="element-267" data-mp="1e3gc8jmuzvhu" />
          <Button variant="luxury" size="sm" onClick={scrollToContact} data-id="element-268" data-mp="1e62mir14wp3r">
            {t('nav.cta')}
          </Button>
        </div>

        <div className="flex lg:hidden items-center gap-4" data-id="element-269" data-mp="1n465pgond9se">
          <LanguageToggle data-id="element-270" data-mp="1n2l8fjay7cqu" />
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-brand-dark p-2" aria-label="Menu" data-id="element-271" data-mp="1s3irrz7p2ctx">
            {isMobileMenuOpen ? <XIcon strokeWidth={1.5} data-id="element-272" data-mp="3tum1mm9rfndf" /> : <MenuIcon strokeWidth={1.5} data-id="element-273" data-mp="3tx89yo4h66wp" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-274" data-mp="3mdpj5vozp9dk">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.4,
        ease: [0.33, 1, 0.68, 1]
      }} className="lg:hidden bg-brand-cream border-t border-brand-stone overflow-hidden" data-id="element-275" data-mp="3hjv2z28lfcj8">
            <div className="container mx-auto px-6 py-8 flex flex-col gap-6" data-id="element-276" data-mp="3vazvlkdjn4k2">
              {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-sm font-medium tracking-widest uppercase text-brand-dark py-2 border-b border-brand-stone/50" data-id="element-277" data-mp="3qcye33vrndap">
                  {link.label}
                </a>)}
              <Button variant="luxury" className="mt-6 w-full" onClick={scrollToContact} data-id="element-278" data-mp="cdt2wi7mbgbd">
                {t('nav.cta')}
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}